import {useRouter} from 'next/router';

export const useIsHomepage = (): boolean => {
  const router = useRouter();
  return router.pathname === '/' || router.asPath === '/';
};
